<div class="banner" *ngIf="IsAd && MainAD">
    <img src="{{MainAD.image_url}}" *ngIf="IsMobile" (click)="OpenUrl(MainAD)"/>
    <img src="{{MainAD.image_url}}" *ngIf="!IsMobile" (click)="OpenUrl(MainAD)"/>
    <div class="close" (click)="closeAd()">
        <i class="icon icon-close">&#xe802;</i>
    </div>
</div>

<div class="raw mainSlider">
    <div class="col-12 tab-bar">
        <div class="tab">
            <label class="active">熱門產業</label>
            <a routerLink="/area">
                <label>買主地區</label>
            </a>
        </div>
        <a routerLink="/sort">
            <div class="more">所有產業類別</div>
        </a>
    </div>

    <div class="col-12 tab-direct">
        <div class="before" id="before"><i class="icon icon-circle-arrow-left">&#xe80b;</i>上一個</div><div class="next" id="next">下一個<i class="icon icon-circle-arrow-right">&#xe80c;</i></div>
    </div>
    
    <div class="col-12 animated fadeIn" *ngIf="Industries">
        <div class="swiper-container">
            <div class="swiper-wrapper">

                <ng-container *ngFor="let item of Industries;let _index = index;">
                    <div class="item swiper-slide" [attr.data-id]="_index">
                        <div class="imgbox">
                            <img src="{{item.icon}}"/>
                        </div>
                        <label>{{item.name}}</label>
                            <p>{{item.desc}}</p>
                    </div>
                </ng-container>
                <!-- <div class="item swiper-slide">
                    <img src="../assets/images/s1.png"/>
                    <label>五金手工／扣件</label>
                    <p>Gym Equipment／gear cutting machine／gear cutting tools…</p>
                </div>
                <div class="item swiper-slide">
                    <img src="../assets/images/s2.png"/>
                    <label>機械／工具機</label>
                    <p>Machinery／Metalworking／模具自動化機械設備／智慧機械／機器...</p>
                </div>
                <div class="item swiper-slide">
                    <img src="../assets/images/s3.png"/>
                    <label>食品／農產品</label>
                    <p>高粱酒／牛軋糖／果凍／餅乾／各類果乾</p>
                </div>
                <div class="item swiper-slide">
                    <img src="../assets/images/s4.png"/>
                    <label>資通訊電子零組件／ 綠能產品</label>
                    <p>LED Drive／PCB／PCBA／Electronic Components</p>
                </div>
                <div class="item swiper-slide">
                    <img src="../assets/images/s5.png"/>
                    <label>紡織／服飾配件</label>
                    <p>Sport Function Fabric／Bicycle accessories／frames／saddles…</p>
                </div>
                <div class="item swiper-slide">
                    <img src="../assets/images/s6.png"/>
                    <label>化學／橡塑膠／儀器／光學／紙／包裝</label>
                    <p>G在線PH/ORP變送器／防護裝備(防疫用)／異丙醇／Projector... </p>
                </div> -->
              </div>
          </div>
    </div>
    
</div>

<div class="raw main">
    <div class="col-12">
        <div class="col-3 left">

            <left-select></left-select>
            
            <div class="block" *ngIf="!IsMobile">
                <ng-container *ngFor="let item of SideAD">
                    <img src="{{item.image_url}}" (click)="OpenUrl(item)"/>
                </ng-container>
                <img *ngIf="Isinfo" src="../assets/images/left4.png"/>
            </div>
        </div>
        <div class="col-9 right">
            <div class="news" *ngIf="NewsData">
                <label>最新消息</label>
                <ul id="marquee" class="marquee">
                    <ng-container *ngFor="let item of NewsData">
                        <li>
                            <a href="{{item.url}}" target="_blank">{{item.text}}</a>
                        </li>
                    </ng-container>
                </ul>
            </div>
            <div class="case">
                <h1>熱門採購案 </h1>
                <div class="content animated fadeIn" *ngIf="HotData">

                    <!-- 卡片狀態
                    card online : 熱烈報名中
                    card end : 報名截止
                    card standby : 候補報名
                    card online : 熱烈報名中

                    <span class="date lasted">06/03(三)</span>
                    lasted : 是否最新
                -->
                    <ng-container *ngFor="let item of HotData">

                        <div class="card {{item.statusClass}}">
                            <div class="item" routerLink="/activity/{{item.id}}">
                                <div class="status"><span>{{item.statusName}}</span></div>
                                <span class="date {{(item.is_new) ? 'lasted' : ''}}">{{item.eventShortDate}}</span>
                                <label>{{item.name}}</label>
                                <p>
                                    <span class="date">報名日期｜{{item.enrollDate}}</span>
                                    <span class="info">{{item.typeName}}</span>
                                </p>
                                <a routerLink="/activity/{{item.id}}"><span class="view">查看詳情</span></a>
                            </div>
                        </div>

                    </ng-container>

                    <empty *ngIf="HotData.length == 0"></empty>
                    <!-- <div class="card online">
                        <div class="item" routerLink="/activity">
                            <div class="status"><span>熱烈報名中</span></div>
                            <span class="date lasted">06/03(三)</span>
                            <label>2020年「台北國際電腦展」線上採購洽談會</label>
                            <p>
                                <span class="date">報名日期｜04/22 12:00 - 05/10 12:00</span>
                                <span class="info">線上洽談</span>
                            </p>
                            <a routerLink="/activity"><span class="view">查看詳情</span></a>
                        </div>
                    </div>
                    -->

                </div>
            </div>
        </div>

        <div class="col-3 left" *ngIf="IsMobile">
            <div class="block">
                <ng-container *ngFor="let item of SideAD">
                    <img src="{{item.image_url}}" (click)="OpenUrl(item)"/>
                </ng-container>
                <img *ngIf="Isinfo" src="../assets/images/left4.png"/>
            </div>
        </div>
    </div>
    
</div>